export enum ChatView {
  DEFAULT = "default",
  OVERLAY = "overlay",
}
